import { Component, OnInit, OnDestroy } from "@angular/core";
import { UserService } from "../../service/user.service";
import { ActivatedRoute } from "@angular/router";
import * as firebase from "firebase";

@Component({
  selector: "app-profil",
  templateUrl: "./profil.component.html",
  styleUrls: ["./profil.component.css"]
})
export class ProfilComponent implements OnInit, OnDestroy {
  user: any = [];
  userRoute: any;
  statistikaRoute: any;
  stastitka: any = [];
  userid: string;

  constructor(private userService: UserService, private rote: ActivatedRoute) {
    this.userid = this.rote.snapshot.params["id"];
    this.userRoute = firebase
      .database()
      .ref("users/")
      .child(this.userid);

    this.statistikaRoute = firebase
      .database()
      .ref("/statistika")
      .child(this.userid);
  }

  ngOnInit() {
    this.userRoute.once("value").then(snapshot => {
      this.user = snapshot.val();
    });

    this.statistikaRoute.on("child_added", data => {
      this.stastitka.push({
        key: data.key,
        data: data.val()
      });
    });
  }
  ngOnDestroy() {
    this.statistikaRoute.off();
  }
}
